import { defineMessages } from 'react-intl';

export const locationResultsListsV2Messages = defineMessages({
  viewMapButton: {
    defaultMessage: 'View map',
    description: 'Location Search | "View map" button | Label',
  },
});
